import React from "react";

function LogoutContent({ status = "loading" }) {
  if (status === "error") {
    return (
      <>
        <p className="text-lg text-red-400">Error al cerrar sesión</p>
        <p className="text-sm text-gray-400 mt-2">Redirigiendo automáticamente...</p>
      </>
    );
  }

  return <p className="text-lg text-white">Cerrando sesión...</p>;
}

export default LogoutContent;
